import { Divider, Form, Tag } from 'antd';
import AntdFormItem from '../../../components/AntdFormItem';
import AntdInput from '../../../components/AntdInput';
import { useIntl } from 'react-intl';
import TextArea from 'antd/es/input/TextArea';
import AntdSelect from '../../../components/AntdSelect';
import timezones from '../../../constants/timezones.json';
import { useContext, useEffect, useMemo, useState } from 'react';
import WithBackButton from '../../../layout/WithBackButton';
import AccionaButton from '../../../components/AccionaButton';
import { useForm } from 'antd/es/form/Form';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearCreateProjectsState,
  createProject,
  deleteProject,
  editProject,
  getProject,
} from '../../../services/redux/projects/actions';
import UploadFile from '../../../components/UploadFile';
import AccionaResult from '../../../components/AccionaResult';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { MainContext } from '../../../context/MainContext';
import { v4 as uuidv4 } from 'uuid';
import { createFile, getFile } from '../../../services/api/files';
import AccionaConfirm from '../../../components/AccionaConfirm';
import { SettingOutlined } from '@ant-design/icons';
import ProviderConfigModal from './components/ProviderConfigModal';

const Create = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [projectImage, setProjectImage] = useState();
  const [uteImage, setUteImage] = useState();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { id: idProject } = useParams();
  const [form] = useForm();
  const [showConfgProviderModal, setShowConfgProviderModal] = useState(false);
  const [confProvider, setConfgProvider] = useState({});
  const [idProviderModal, setIdProviderModal] = useState();
  const [selectedProviders, setSelectedProviders] = useState([]);
  const {
    isDeleted,
    isCreated,
    errorMessages,
    list: projects,
  } = useSelector(({ projects }) => projects);
  const concrete_providersOptions = useMemo(
    () => [
      {
        id_provider: 1,
        name: 'OTHER',
      },
      {
        id_provider: 2,
        name: 'CEMEX',
      },
    ],
    [],
  );
  const laboratory_providersOptions = useMemo(
    () => [
      {
        id_provider: 1,
        name: 'OTHER',
      },
    ],
    [],
  );
  const { setLoading, setError } = useContext(MainContext);
  const outlet = useOutletContext();
  const allTimezones = useMemo(
    () =>
      timezones.zones
        .map((timezone) => ({
          label: `${timezone.location?.countryName} (${timezone.id})`,
          value: `${timezone.location?.countryName}:${timezone.id}:${timezone.location?.countryCode}`,
        }))
        .filter((timezone) => !timezone.label.includes('undefined'))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [],
  );

  const handleOnDelete = () => {
    setShowConfirmModal({
      message: intl.formatMessage({
        id: 'projects.delete.message',
      }),
      onConfirm: () => {
        setLoading(true);
        dispatch(deleteProject(idProject));
        setShowConfirmModal();
      },
      onCancel: () => {
        setShowConfirmModal();
      },
    });
  };

  const handleOnFinish = async ({ zone, ...values }) => {
    const laboratory_providers = values.laboratory_providers.map(
      (idProvider) => {
        const providerFound = laboratory_providersOptions.find(
          (prov) => prov.id_provider === idProvider,
        );
        const response = {
          provider: providerFound.name,
        };
        return response;
      },
    );

    const concrete_providers = values.concrete_providers.map((idProvider) => {
      const providerFound = concrete_providersOptions.find(
        (prov) => prov.id_provider === idProvider,
      );
      const response = {
        provider: providerFound.name,
      };
      if (providerFound.name !== 'OTHER') {
        response.config = confProvider;
      }
      return response;
    });

    const providerCEMEX = concrete_providers.find(
      (cp) => cp.provider === 'CEMEX',
    );

    if (providerCEMEX && !providerCEMEX.config.password) {
      form.setFields([
        {
          name: 'concrete_providers',
          errors: [
            intl.formatMessage({
              id: 'projects.create.concrete_providers.cemex.modal.password.alert',
            }),
          ],
        },
      ]);

      return;
    }

    const splitZone = zone.split(':');
    setLoading(true);
    setProjectImage(values.projectImage);
    setUteImage(values.uteFilename);
    const uteFilename = uuidv4() + '.' + values.ute_image.name.split('.').pop();
    const projectFilename =
      uuidv4() + '.' + values.project_image.name.split('.').pop();
    await createFile({
      file: values.project_image,
      model: 'projects-image',
      filename: projectFilename,
    });
    await createFile({
      file: values.ute_image,
      model: 'projects-image',
      filename: uteFilename,
    });

    if (idProject) {
      dispatch(
        editProject({
          id: parseInt(idProject, 10),
          ...values,
          laboratory_providers,
          concrete_providers,
          country_code: splitZone[2],
          timezone: splitZone[1],
          ute_image: uteFilename,
          project_image: projectFilename,
        }),
      );
    } else {
      dispatch(
        createProject({
          ...values,
          laboratory_providers,
          concrete_providers,
          country_code: splitZone[2],
          timezone: splitZone[1],
          ute_image: uteFilename,
          project_image: projectFilename,
        }),
      );
    }
  };

  const getTagProviders = ({ label, value, closable, onClose }) => {
    return (
      <Tag
        closable={closable}
        onClose={onClose}
        style={{
          display: 'flex',
          alignItems: 'center',
          marginRight: 3,
          paddingRight: 8,
          backgroundColor: '#0000000f',
          border: 'none',
          borderRadius: 4,
          height: '35px',
        }}
      >
        <span style={{ fontSize: '16px' }}>{label}</span>
        {label !==
          intl
            .formatMessage({
              id: 'projects.create.concrete_providers.other',
            })
            .toLocaleUpperCase() && (
          <SettingOutlined
            onMouseDown={(e) => {
              e.preventDefault(); // evita que el input reciba foco
              e.stopPropagation(); // evita que el evento burbujee al Select
            }}
            onClick={(e) => {
              e.stopPropagation(); // Evita que se cierre el tag al hacer click
              setIdProviderModal(value);
              setShowConfgProviderModal(true);
            }}
            style={{ marginLeft: 7, cursor: 'pointer', fontSize: '16px' }}
          />
        )}
      </Tag>
    );
  };

  const handleChangeProvidersOptions = (providerOption) => {
    const previousValues = selectedProviders;
    const added = providerOption.find((val) => !previousValues.includes(val));
    const removed = previousValues.find((val) => !providerOption.includes(val));

    setSelectedProviders(providerOption);

    if (added) {
      const addedObj = concrete_providersOptions.find(
        (p) => p.id_provider === added,
      );
      if (addedObj?.name !== 'OTHER') {
        setIdProviderModal(added);
        setShowConfgProviderModal(true);
      }
    }

    if (removed) {
      const removedObj = concrete_providersOptions.find(
        (p) => p.id_provider === removed,
      );
      if (removedObj?.name !== 'OTHER') {
        setConfgProvider({});
      }
    }
  };

  const mainRules = [
    {
      required: true,
      message: intl.formatMessage({ id: 'validations.required' }),
    },
  ];

  useEffect(() => {
    if (idProject) {
      dispatch(getProject(idProject));
    }
  }, [dispatch, idProject]);

  useEffect(() => {
    if (idProject && projects?.length) {
      const { ute_image, project_image, ...project } = projects.find(
        (project) => project.id_project === parseInt(idProject, 10),
      );
      const concrete_providers_selected = project.concrete_providers
        .map(({ provider }) => {
          const found = concrete_providersOptions.find(
            (p) => p.name === provider,
          );
          if (!found) return null;
          return found.id_provider;
        })
        .filter(Boolean);

      setSelectedProviders(concrete_providers_selected);

      const timezone = timezones.zones.find(
        (timezone) =>
          timezone.location?.countryCode === project?.country_code &&
          timezone.id === project.timezone,
      );

      const laboratory_providers_selected = project.laboratory_providers
        .map(({ provider }) => {
          const found = laboratory_providersOptions.find(
            (p) => p.name === provider,
          );
          if (!found) return null;
          return found.id_provider;
        })
        .filter(Boolean);

      form.setFieldsValue({
        ...project,
        id_normative: project.normative_data.id_normative,
        concrete_providers: concrete_providers_selected,
        zone: `${timezone.location?.countryName}:${timezone.id}:${timezone.location?.countryCode}`,
        laboratory_providers: laboratory_providers_selected,
      });

      setConfgProvider(
        project.concrete_providers.find((cp) => cp.provider === 'CEMEX')
          ?.config || {},
      );
    }
  }, [
    form,
    idProject,
    intl,
    projects,
    concrete_providersOptions,
    laboratory_providersOptions,
  ]);

  useEffect(() => {
    const getImages = async (project) => {
      if (project.project_image) {
        await getFile(project.project_image, 'projects-image')
          .then((value) => {
            const file = new File([value.data], project.project_image, {
              type: value.data.type,
            });
            form.setFieldsValue({
              project_image: file,
            });
            setProjectImage(file);
          })
          .catch((error) => {
            console.error(error);
          });
      }

      if (project.ute_image) {
        await getFile(project.ute_image, 'projects-image')
          .then((value) => {
            const file = new File([value.data], project.ute_image, {
              type: value.data.type,
            });
            form.setFieldsValue({
              ute_image: file,
            });
            setUteImage(file);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    };
    if (outlet?.project) {
      getImages(outlet?.project);
    }
  }, [form, outlet]);

  useEffect(() => {
    return () => {
      dispatch(clearCreateProjectsState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (isCreated) {
      setLoading(false);
    }
  }, [isCreated, setLoading]);

  useEffect(() => {
    if (isDeleted) {
      setLoading(false);
      navigate('/app/projects');
    }
  }, [isDeleted, navigate, setLoading]);

  useEffect(() => {
    if (errorMessages) {
      setError(errorMessages);
    }
  }, [errorMessages, setError]);

  if (isCreated) {
    return (
      <AccionaResult
        id="succesResult"
        icon={
          <i
            className="fas fa-check-circle fa-8x"
            style={{ color: '#82c91e' }}
          />
        }
        title={intl.formatMessage({
          id: `projects.${idProject ? 'edit' : 'create'}.result.title`,
        })}
        className="success"
        extra={[
          <div key="1" style={{ marginTop: '24px' }}>
            <div key="extraSuccess1" className="form-row">
              <AccionaButton
                id="successBtn"
                onClick={() => {
                  navigate('../projects');
                }}
                msg={intl.formatMessage({ id: 'button.create.end' })}
              />
            </div>
          </div>,
        ]}
      />
    );
  }

  const MainComponent = () => (
    <>
      <div className="row">
        <div
          className="col-sm-12"
          style={{ backgroundColor: '#ffffff', padding: '20px' }}
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={handleOnFinish}
            autocomplete="off"
          >
            <div className="row" style={{ display: 'flex' }}>
              <div className="col-sm-12 col-md-6">
                <AntdFormItem
                  style={{ marginBottom: '20px' }}
                  name="name"
                  label={intl.formatMessage({
                    id: 'projects.create.name.label',
                  })}
                  rules={[...mainRules, { min: 5 }, { max: 50 }]}
                >
                  <AntdInput
                    placeholder={intl.formatMessage({
                      id: 'projects.create.name.placeholder',
                    })}
                    size="xLarge"
                  />
                </AntdFormItem>
                <AntdFormItem
                  label={intl.formatMessage({
                    id: 'projects.create.description.label',
                  })}
                  name="description"
                  rules={[...mainRules, { min: 5 }, { max: 200 }]}
                  style={{ marginBottom: '20px' }}
                >
                  <TextArea
                    placeholder={intl.formatMessage({
                      id: 'projects.create.description.placeholder',
                    })}
                    style={{ height: '137px', resize: 'none' }}
                  />
                </AntdFormItem>
                <AntdFormItem
                  style={{ marginBottom: '20px' }}
                  name="work_code"
                  label={intl.formatMessage({
                    id: 'projects.create.work_code.label',
                  })}
                  rules={[...mainRules, { min: 5 }, { max: 30 }]}
                >
                  <AntdInput
                    placeholder={intl.formatMessage({
                      id: 'projects.create.work_code.placeholder',
                    })}
                    size="xLarge"
                  />
                </AntdFormItem>
                <AntdFormItem
                  name="concrete_providers"
                  label={intl.formatMessage({
                    id: 'projects.create.concrete_providers.label',
                  })}
                  style={{ marginBottom: '20px' }}
                  rules={mainRules}
                  disabled
                >
                  <AntdSelect
                    placeholder={intl.formatMessage({
                      id: 'projects.create.concrete_providers.placeholder',
                    })}
                    size="xLarge"
                    options={concrete_providersOptions?.map((provider) => ({
                      value: provider.id_provider,
                      label:
                        provider.name === 'OTHER'
                          ? intl
                              .formatMessage({
                                id: 'projects.create.concrete_providers.other',
                              })
                              .toLocaleUpperCase()
                          : provider.name,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    mode="multiple"
                    tagRender={getTagProviders}
                    onChange={(providerOption) =>
                      handleChangeProvidersOptions(providerOption)
                    }
                  />
                </AntdFormItem>
              </div>
              <div className="col-sm-12 col-md-6">
                <AntdFormItem
                  style={{ marginBottom: '20px' }}
                  name="zone"
                  label={intl.formatMessage({
                    id: 'projects.create.zone.label',
                  })}
                  rules={[...mainRules, { min: 5 }, { max: 50 }]}
                >
                  <AntdSelect
                    placeholder={intl.formatMessage({
                      id: 'projects.create.zone.placeholder',
                    })}
                    size="xLarge"
                    options={allTimezones}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  />
                </AntdFormItem>
                <AntdFormItem
                  style={{ marginBottom: '20px' }}
                  name="requester"
                  label={intl.formatMessage({
                    id: 'projects.create.requester.label',
                  })}
                  rules={[...mainRules, { min: 5 }, { max: 50 }]}
                >
                  <AntdInput
                    placeholder={intl.formatMessage({
                      id: 'projects.create.requester.placeholder',
                    })}
                    size="xLarge"
                  />
                </AntdFormItem>
                <AntdFormItem
                  style={{ marginBottom: '20px' }}
                  name="id_normative"
                  label={intl.formatMessage({
                    id: 'projects.create.normative.label',
                  })}
                  rules={mainRules}
                >
                  <AntdSelect
                    placeholder={intl.formatMessage({
                      id: 'projects.create.normative.placeholder',
                    })}
                    size="xLarge"
                    options={[
                      { label: 'EHE', value: 1 },
                      { label: 'CoE', value: 2 },
                    ]}
                    disabled={idProject}
                  />
                </AntdFormItem>
                <AntdFormItem
                  name="laboratory_providers"
                  label={intl.formatMessage({
                    id: 'projects.create.laboratory_providers.label',
                  })}
                  style={{
                    marginBottom: '20px',
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    right: '0',
                    padding: '0 15px',
                  }}
                  rules={mainRules}
                  disabled
                >
                  <AntdSelect
                    placeholder={intl.formatMessage({
                      id: 'projects.create.laboratory_providers.placeholder',
                    })}
                    size="xLarge"
                    options={laboratory_providersOptions?.map((provider) => ({
                      value: provider.id_provider,
                      label:
                        provider.name === 'OTHER'
                          ? intl
                              .formatMessage({
                                id: 'projects.create.laboratory_providers.other',
                              })
                              .toLocaleUpperCase()
                          : provider.name,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    mode="multiple"
                  />
                </AntdFormItem>
              </div>
            </div>
            <div className="row" style={{ marginBottom: '40px' }}>
              <div className="col-sm-12 col-md-6">
                <AntdFormItem
                  style={{ marginBottom: '20px' }}
                  name="project_image"
                  label={intl.formatMessage({
                    id: 'projects.create.project_image.label',
                  })}
                  rules={mainRules}
                >
                  <UploadFile
                    accept={'image/*'}
                    fileList={projectImage ? [projectImage] : []}
                  />
                </AntdFormItem>
              </div>
              <div className="col-sm-12 col-md-6">
                <AntdFormItem
                  style={{ marginBottom: '20px' }}
                  name="ute_image"
                  label={intl.formatMessage({
                    id: 'projects.create.ute_image.label',
                  })}
                  rules={mainRules}
                >
                  <UploadFile
                    accept={'image/*'}
                    fileList={uteImage ? [uteImage] : []}
                  />
                </AntdFormItem>
              </div>
            </div>
            <Divider />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <AccionaButton
                onClick={() => form.submit()}
                classIcon="fas fa-check"
                msg={intl.formatMessage({
                  id: `projects.${idProject ? 'edit' : 'create'}.button`,
                })}
              />
              {idProject && (
                <AccionaButton
                  onClick={handleOnDelete}
                  classIcon="fas fa-trash"
                  msg={intl.formatMessage({
                    id: `projects.delete.button`,
                  })}
                  type="default"
                />
              )}
            </div>
          </Form>
        </div>
      </div>

      <ProviderConfigModal
        open={showConfgProviderModal}
        closeModal={() => setShowConfgProviderModal(false)}
        setConfgProvider={setConfgProvider}
        confProvider={confProvider}
        idProviderModal={idProviderModal}
        deleteProvider={(proyectValues) => form.setFieldsValue(proyectValues)}
        proyectValues={form.getFieldsValue()}
        setSelectedProviders={setSelectedProviders}
      />

      {showConfirmModal && (
        <AccionaConfirm
          message={showConfirmModal.message}
          onCancel={showConfirmModal.onCancel}
          onConfirm={showConfirmModal.onConfirm}
        />
      )}
    </>
  );
  const MainComponentWithButtons = WithBackButton(MainComponent);

  return <MainComponentWithButtons />;
};

export default Create;
